import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './GuestCountFilterPopover.scss';

interface GuestCountFilterPopoverProps {
  onGuestCountSelection: (guestCount: number) => void;
  maxReservationGuests: number;
}

export const GuestCountFilterPopover = ({
  onGuestCountSelection,
  maxReservationGuests,
}: GuestCountFilterPopoverProps) => {
  const guestCountPossibilities = Array.from(
    { length: maxReservationGuests },
    (_, index) => index + 1,
  );

  return (
    <div className={styles.popover} data-testid="guest-count-filter-popover">
      <h1 className={cx(typography.h7, styles.guestCountHeader)}>Guests</h1>

      <div role="group" className={styles.guestCountContainer}>
        {guestCountPossibilities.map((guestCount) => {
          return (
            <button
              aria-label={`${guestCount} guests`}
              className={cx(typography.t1, styles.guestCountOptionButton)}
              type="button"
              onClick={() => onGuestCountSelection(guestCount)}
              key={guestCount}
            >
              {guestCount}
            </button>
          );
        })}
      </div>
    </div>
  );
};
